class TabMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabButtons = this.querySelectorAll('.tab-button');
    this.tabContents = this.querySelectorAll('.tab-content');
    this.setInitialTabAndContent();
    this.addButtonClickHandlers();
  }

  setInitialTabAndContent() {
    const initialActiveButton = this.querySelector('[data-tab="account-details"]');
    const initialActiveContent = this.querySelector('[data-content="account-details"]');
    if (initialActiveButton && initialActiveContent) {
      initialActiveButton.classList.add('tw-border-b-[1px]', 'tw-border-primary-black');
      initialActiveButton.classList.add('tw-flex');
      this.tabContents.forEach((content) => {
        if (content !== initialActiveContent) {
          content.classList.remove('tw-flex');
          content.classList.add('tw-hidden');
        }
      });
    }
  }

  addButtonClickHandlers() {
    this.tabButtons.forEach((button) =>
      button.addEventListener('click', () => {
        const targetTab = button.getAttribute('data-tab');
        const targetContent = Array.from(this.tabContents).filter(
          (content) => content.getAttribute('data-content') === targetTab
        );

        this.tabButtons.forEach((btn) => btn.classList.remove('tw-border-b-[1px]', 'tw-border-primary-black'));
        this.tabContents.forEach((content) => content.classList.add('tw-hidden'));
        this.tabContents.forEach((content) => content.classList.remove('tw-flex'));

        button.classList.add('tw-border-b-[1px]', 'tw-border-primary-black');
        targetContent[0].classList.remove('tw-hidden');
        targetContent[0].classList.add('tw-flex');
      })
    );
  }
}

customElements.define('tab-menu', TabMenu);
